import axios from "axios";
import { baseURLs } from "./baseURL";
import { toast } from "views/utilities/MyCustomFile"

const client = axios.create({ baseURL: baseURLs() });
export const AxiosRequest = ({ ...options }) => {
    let authToken = sessionStorage.getItem("token")
    if (authToken) {
        client.defaults.headers.common.Authorization = authToken;
    }
    return client(options).catch(error => {
        if (error.response.status === 500) {
            alert(error.response.data.message)
            return { data: { status: false, message: [] } }
        } else if (error.response.status === 409 || error.response.status === 400) {
            toast.error(error.response.data.message);
            return { data: { status: false, setDisable: true } }
        } else if (error.response.status === 401) {
            window.location.href = "/login"
            sessionStorage.clear();
        }
    })
}
